// Card
export const CARD_WIDTH = 320;
export const CARD_HEIGHT = 320;

// Card grid
export const CARD_GRID_COLUMN_GAP = 20;
export const CARD_GRID_ROW_GAP = 20;

// Card grid container
export const CARD_GRID_PERCENTAGE = 0.85;

// Main filter
export const FIELD_WIDTH = 250;
export const FIELD_WIDTHS = {
  XS: FIELD_WIDTH / 4,
  S: FIELD_WIDTH / 3,
  M: FIELD_WIDTH / 2,
  L: (FIELD_WIDTH * 2) / 3,
  XL: FIELD_WIDTH,
  XXL: FIELD_WIDTH * 1.5,
};

export const FIELD_MARGIN_RIGHT = 10;
export const LABEL_WIDTH = 70;
export const ITEMS_PER_PAGE = 8;
export const ICON_SIZE = 20;

export const COLORS = {
  white: "rgb(255, 255, 255)",
  grey: "rgb(76, 76, 76)",
  green: "#82b8ba",
  orange: "#f39677",
  lylac: "#bbb2c4",
  blue: "#5382a4",
};

export const facilityIconSize = 30;

export const LAYOUT = {
  ICON_SIZE: 20,
};

export const INITIAL_PAGINATION_PAGE_SIZE = 12;

export const INTERVAL_BETWEEN_VILLAGE_IMAGES = 6000;
